import { getSignInUrl } from '@notes/webintegrations-common'
import { getMsaSignInUrl } from '@notes/webintegrations-common/lib/Auth/Url/getSignInUrl'
import { USE_IMPLICIT_AUTH_FOR_MSA } from './useImplicitAuthForMsa'

export function getForceSignInUrl(selectAccount: boolean): string {
  // Use the current url, since it could be onenote.com/stickynotes or onenote.com/officeaddins/stickynotes
  const currentUrl = window.location.href // Note current url already has dev parameters
  return getSignInUrl(currentUrl, USE_IMPLICIT_AUTH_FOR_MSA, 1, selectAccount ? 'select_account' : undefined)
}

export function getMsaImplicitGrantSignInUrl(): string {
  const currentUrl = window.location.href // Note current url already has dev parameters
  return getMsaSignInUrl(currentUrl)
}

const signInUrlTemplate = 'https://login.live.com/oauth20_authorize.srf?client_id=6b276b59-3b21-4d3b-8a6d-3ad8a955e3b8&' +
  'scope={0}&' +
  'redirect_uri={1}&' +
  'response_type=token&' +
  'nonce=3bc1c8b8-4885-4dc4-9bef-9e6ede23e8b5'

export function getImplicitGrantUrl(scope: string): string {
  const redirectUrl = window.location.href.split('#')[0] // Preserve dev params, but don't capture fragment
  return signInUrlTemplate
    .replace('{0}', encodeURIComponent(scope))
    .replace('{1}', encodeURIComponent(redirectUrl))
}
